




import { Component, Watch, Vue } from 'vue-property-decorator'

import '@github/time-elements'
import '@/global-types.ts'

@Component({})
export default class App extends Vue {
  @Watch('$store.state.viewSettings.darkMode')
  changeDarkmode (n: boolean) {
    this.$vuetify.theme.dark = n
  }

  created () {
    this.$store.dispatch('restore')
  }
}
